import React, { useEffect, useRef } from 'react';
import './Mission.css';

const Mission = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add('mission-visible');
        } else {
          section.classList.remove('mission-visible');
        }
      },
      { threshold: 0.3 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="mission-section" ref={sectionRef}>
      <div className="mission-content">
        <h2>Our Mission</h2>
        <p>
          "To promote socio-economic progress, environmental stewardship, and good governance through collaborative efforts, innovative solutions, and effective service delivery in partnership with all stakeholders."
        </p>
        <p>
          At Igbo-Eze North, we believe in planning with purpose and governing with accountability. From upgrading schools and healthcare centres to enhancing agricultural productivity and community safety, we are building a local government that works — for everyone.
        </p>
      </div>
    </section>
  );
};

export default Mission;